const applicationName = import.meta.env.VITE_APP_NAME || 'Platform Forms';

export const brand = Object.freeze({
  applicationName,
  companyName: 'Platform',
  shortName: 'Forms',
  description: 'Build, publish and manage Platform forms.',
  accentColour: '#ef5b3f',
  themeColour: '#050505',
});

export const fontStack = [
  'Inter',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  'Oxygen',
  'Ubuntu',
  'Cantarell',
  '"Fira Sans"',
  '"Droid Sans"',
  '"Helvetica Neue"',
  'sans-serif',
].join(', ');
